<template>
  <div v-if="$store.state.modal3">
    <v-dialog v-model="$store.state.modal3" persistent max-width="1900">
      <v-toolbar color="blue" dark>
        <v-card-title class="text-xs-center headline">
          <v-icon>mdi-settings</v-icon>Configuración Pulsos
        </v-card-title>
        <v-spacer />

        <v-card-title class="text-xs-center headline">
          <!-- <h4 v-if="$store.state.meteo">
            <v-icon>mdi-white-balance-sunny</v-icon>Radiación Acumulada:
            <strong>
              {{
                (
                  $store.state.meteo.specificTypeParameters.solarRadiationAcc /
                  10000
                ).toFixed(2)
              }}J
            </strong>
          </h4> -->
        </v-card-title>
        <v-spacer />
        <v-spacer />
        <v-tooltip bottom z-index="99999">
          <template v-slot:activator="{ on }">
            <div>
              <v-btn flat v-on="on" @click="closeSave()">
                <!-- <v-icon>mdi-close-circle-outline</v-icon> -->
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
          </template>
          <span>Cerrar</span>
        </v-tooltip>
      </v-toolbar>
      <v-card class="content">
        <!-- BUTTONS CONTROLS -->
        <div v-if="charts" class="historic-charts">
          <chart />
          <hr />
        </div>

        <br />
        <!-- INPUT PARA HORA INICIAL DE RIEGO -->
        <v-layout row wrap>
          <v-flex></v-flex>
          <v-layout row wrap>
            <v-flex class="text-md-right" xs1 sm1 md1 lg1>
              <h4>
                <v-icon>mdi-calendar-clock</v-icon>
              </h4>
            </v-flex>
            <v-flex xs4 sm4 md4 lg4>
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :nudge-right="10"
                :nudge-top="70"
                :return-value.sync="time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="300px"
                min-width="300px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="initialTimes[0]"
                    label="Hora Inicial de Riego"
                    prepend-icon
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menu"
                  v-model="initialTimes[0]"
                  full-width
                  @click:minute="save(time)"
                />
              </v-menu>
            </v-flex>
            <v-spacer></v-spacer>
          </v-layout>
          <v-flex></v-flex>

          <v-flex>
            <v-checkbox
              v-model="secondPulse"
              :label="`SEGUNDO PULSO`"
              @change="addSecondPulse(secondPulse)"
            ></v-checkbox>
          </v-flex>
          <v-flex>
            <v-btn
              :disabled="total > 100 || totalB > 100"
              class="close"
              round
              right
              color="light-green lighten-1"
              dark
              @click="calculate(false)"
            >
              <v-icon>mdi-av-timer</v-icon>Calcular
            </v-btn>
          </v-flex>
        </v-layout>
        <!-- <br> -->
        <v-layout row>
          <v-flex lg8 md8 sm12 xs12>
            <!-- TABLA DE SECTORES DE RIEGO -->
            <h3>Sectores de Riego</h3>
            <table>
              <v-layout>
                <v-flex lg12 md12 sm12 xs12>
                  <thead>
                    <tr>
                      <th class="head text-xs-center">Nombre</th>
                      <th class="head text-xs-center">Sector</th>
                      <th class="head text-xs-center">Cabezal</th>
                      <th class="head text-xs-center">ml Riego</th>
                      <th class="head text-xs-center">pH</th>
                      <th class="head text-xs-center">Comentarios</th>
                    </tr>
                  </thead>
                </v-flex>
              </v-layout>

              <v-layout>
                <v-flex>
                  <tr v-for="(sector, k) in irrigationInstructions" :key="k">
                    <td class="clickable">{{ sector.name }}</td>
                    <td class="tablebox">
                      <input
                        v-model="sector.sector"
                        class="text-xs-center agro-unit"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="sector.head"
                        class="form-control"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="sector.milliliters"
                        class="form-control"
                        type="number"
                        step="100"
                      />
                    </td>
                    <td>
                      <input
                        v-model="sector.pH"
                        class="form-control"
                        type="text"
                      />
                    </td>
                    <td>
                      <input
                        v-model="sector.comments"
                        placeholder="..."
                        class="form-control"
                        type="text"
                      />
                    </td>
                  </tr>
                </v-flex>
              </v-layout>
            </table>
          </v-flex>

          <!-- TABLA PARA PULSOS -->
          <v-flex lg5 md5 sm12 xs12>
            <div>
              <v-layout row class="controls">
                <v-flex lg3 md3 sm12 xs12>
                  <h3>Pulsos</h3>
                </v-flex>
                <v-flex lg2 md2 sm12 xs12>
                  <v-btn
                    class="control"
                    fab
                    round
                    right
                    color="light-green lighten-1"
                    dark
                    @click="addPulse(0)"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex lg2 md2 sm12 xs12>
                  <v-btn
                    class="control"
                    fab
                    round
                    right
                    color="deep-orange lighten-1"
                    dark
                    @click="removePulse(0)"
                  >
                    <v-icon>mdi-minus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex></v-flex>
              </v-layout>
              <table>
                <v-layout>
                  <v-flex lg12 md12 sm12 xs12>
                    <thead>
                      <tr>
                        <th class="head text-xs-center">No.</th>
                        <th class="head text-xs-center">Porcentaje (%)</th>
                        <!-- <th class="head text-xs-center">CE</th> -->
                        <th class="head text-xs-center">Esperar min.</th>
                      </tr>
                    </thead>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex>
                    <tr v-for="(instruction, k) in instructions[0][0]" :key="k">
                      <td class="tablebox">
                        <input
                          v-model="instruction.position"
                          class="form-control disable text-xs-center"
                          disabled
                          type="text"
                        />
                      </td>
                      <td>
                        <input
                          v-model="instruction.percentage"
                          class="form-control"
                          type="number"
                          step="0.5"
                          @change="calcTotal()"
                        />
                      </td>
                      <!-- <td>
                        <input
                          v-model="instruction.electricConductivity"
                          class="form-control"
                          type="text"
                        />
                      </td>-->
                      <td>
                        <input
                          v-model="instruction.waitTime"
                          class="form-control text-xs-center"
                          type="number"
                          step="1"
                          @change="calcTotal()"
                        />
                      </td>
                    </tr>
                    <template v-if="instructions">
                      <tr>
                        <td />
                        <td>
                          <p :class="total > 100 ? 'err' : ''">
                            Total: {{ total.toFixed(2) }} %
                          </p>
                        </td>
                      </tr>
                    </template>
                  </v-flex>
                </v-layout>
              </table>
              <br />

              <!-- SECOND PULSE -->
              <template v-if="secondPulse == true">
                <v-layout row class="controls">
                  <v-flex xs5 sm5 md5 lg5>
                    <v-layout>
                      <v-flex>
                        <v-flex class="text-md-right" xs1 sm1 md1 lg1>
                          <h4>
                            <v-icon>mdi-calendar-clock</v-icon>
                          </h4>
                        </v-flex>
                        <v-flex xs10 sm10 md10 lg10>
                          <v-menu
                            ref="menu"
                            v-model="menu2"
                            :close-on-content-click="false"
                            :nudge-right="10"
                            :nudge-top="70"
                            :return-value.sync="time2"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            max-width="300px"
                            min-width="300px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="initialTimes[1]"
                                label="Hora Inicial de Riego"
                                prepend-icon
                                readonly
                                v-on="on"
                              />
                            </template>
                            <v-time-picker
                              v-if="menu2"
                              v-model="initialTimes[1]"
                              full-width
                              @click:minute="save2(time2)"
                            />
                          </v-menu>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                  </v-flex>
                  <v-flex lg4 md4 sm12 xs12>
                    <h3>#2 Pulsos</h3>
                  </v-flex>
                  <v-flex lg2 md2 sm12 xs12>
                    <v-btn
                      class="control"
                      fab
                      round
                      right
                      color="light-green lighten-1"
                      dark
                      @click="addPulse(1)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex lg2 md2 sm12 xs12>
                    <v-btn
                      class="control"
                      fab
                      round
                      right
                      color="deep-orange lighten-1"
                      dark
                      @click="removePulse(1)"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex></v-flex>
                </v-layout>
                <table>
                  <v-layout>
                    <v-flex lg12 md12 sm12 xs12>
                      <thead>
                        <tr>
                          <th class="head text-xs-center">No.</th>
                          <th class="head text-xs-center">Porcentaje (%)</th>
                          <!-- <th class="head text-xs-center">CE</th> -->
                          <th class="head text-xs-center">Esperar min.</th>
                        </tr>
                      </thead>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex>
                      <tr
                        v-for="(instruction, k) in instructions[1][0]"
                        :key="k"
                      >
                        <td class="tablebox">
                          <input
                            v-model="instruction.position"
                            class="form-control disable text-xs-center"
                            disabled
                            type="text"
                          />
                        </td>
                        <td>
                          <input
                            v-model="instruction.percentage"
                            class="form-control"
                            type="number"
                            step="0.5"
                            @change="calcTotalB()"
                          />
                        </td>
                        <!-- <td>
                          <input
                            v-model="instruction.electricConductivity"
                            class="form-control"
                            type="text"
                          />
                        </td>-->
                        <td>
                          <input
                            v-model="instruction.waitTime"
                            class="form-control text-xs-center"
                            type="number"
                            step="1"
                            @change="calcTotalB()"
                          />
                        </td>
                      </tr>
                      <template v-if="instructions">
                        <tr>
                          <td />
                          <td>
                            <p :class="totalB > 100 ? 'err' : ''">
                              Total: {{ totalB.toFixed(2) }} %
                            </p>
                          </td>
                        </tr>
                      </template>
                    </v-flex>
                  </v-layout>
                </table>
              </template>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import moment from "moment-timezone";
import Chart from "./HistoricalCharts.vue";
// import axiosApi from "../../axios-api";

// HACE FALTA DIVIDIR POR CABEZAL
import splitByHead from "../../utils/pulseIrrigationHelpers/splitByHead";

export default {
  components: {
    Chart,
  },
  data() {
    return {
      time: null,
      time2: null,
      newPulse: null,
      menu: false,
      menu2: false,
      modal2: false,
      charts: false,
      secondPulse: false,
      yesterdayReports: false,
      configPulse: false,
      items: [],
      instructions: [],
      instruction2: [],
      pulses: [],
      irrigationInstructions: null,
      splitIrrigationInstructions: [],
      percentage: [100, 100],
      total: 100,
      totalB: 100,
      initialTimes: [null, null],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
      },
    };
  },
  created() {},
  beforeMount() {
    console.log("TIMES");
    this.irrigationInstructions = [...this.$store.state.irrigationInstructions];

    this.splitIrrigationInstructions = [
      ...this.$store.state.splitIrrigationInstructions,
    ];

    this.irrigationInstructions = this.irrigationInstructions.sort((a, b) =>
      a.sector > b.sector ? 1 : b.sector > a.sector ? -1 : 0
    );

    if (
      this.splitIrrigationInstructions[0] &&
      this.splitIrrigationInstructions[0][0].initialTime
    ) {
      this.initialTimes[0] = this.splitIrrigationInstructions[0][0].initialTime;
    } else {
      this.initialTimes[0] = "09:00";
    }

    if (this.splitIrrigationInstructions[1]) {
      this.secondPulse = true;
      this.initialTimes[1] = this.splitIrrigationInstructions[1][0].initialTime;
      console.log("TIMES 2", this.initialTimes[1]);
    }

    // this.instructions = [...this.$store.state.splitPulses[0][0]];

    if (this.$store.state.splitPulses[0] !== undefined) {
      this.instructions = [...this.$store.state.splitPulses];
      console.log("spli pulsses", this.instructions);
    } else {
      console.log("no spli pulsses");
      this.instructions = [
        [
          [
            {
              position: 1,
              percentage: 100,
              electricConductivity: "0.8",
              waitTime: "0",
              totalMin: 0,
            },
          ],
        ],
      ];
      console.log("....", this.instructions);
    }

    // this.irrigationInstructions.pop();
    // this.irrigationInstructions.pop();
  },
  methods: {
    closeSave() {
      this.$store.commit("modal3", false);
      // this.dialog = false;
    },
    addSecondPulse(secondPulse) {
      if (secondPulse == true) {
        this.instructions.push([]);
        console.log("Toggle", this.instructions);
        this.instructions[1].push([
          {
            position: 1,
            percentage: 100,
            electricConductivity: "0.8",
            waitTime: "0",
            totalMin: 0,
          },
        ]);
        console.log("Toggle", this.instructions);
        console.log("Toggle", this.instructions[1][0]);
      } else {
        this.instructions.pop();
      }
    },
    calculate: function(modal) {
      this.$store.commit("modal3", modal);
      // this.$store.commit("modal2", false);

      // this.$store.commit("configPulse", true);

      // GROUP INSTRUCTION BY HEAD
      this.splitIrrigationInstructions = splitByHead([
        ...this.irrigationInstructions,
      ]);

      console.log("PPP", this.instructions);
      this.splitPulses = [...this.instructions];

      let pulsesArr = [];
      let pulsesHeaders = [];

      this.$store.commit(
        "splitIrrigationInstructions",
        this.splitIrrigationInstructions
      );

      this.splitIrrigationInstructions.map((irrInstByHead, headInd) => {
        let arr = [];
        irrInstByHead.forEach((irrInts, indexIns) => {
          console.log("irrInst", irrInts);
          irrInts.initialTime = this.initialTimes[headInd];
          if (this.splitPulses[headInd] !== undefined) {
            arr.push(this.splitPulses[headInd][indexIns]);
          }
        });
        pulsesArr.push(arr);
        irrInstByHead.push({});
        irrInstByHead.push({});
      });

      console.log("TEST CL", pulsesArr);

      // CREATES TABLE HEADERS
      pulsesArr.forEach((element, i) => {
        pulsesHeaders.push([]);
        element[0].forEach((x, index) => {
          pulsesHeaders[i].push(
            { text: `P. ${index + 1}`, index: `${index + 1}`, align: "center" },
            { text: `CE ${index + 1}`, align: "center" }
          );
        });
      });

      // CALCULATE MINUTES PER PULSE PERCENTAJE
      let pulsesTable = [];
      let newTimes = [];

      pulsesArr.forEach((pulsesByHead, index) => {
        pulsesTable.push([]);
        console.log("pulsesTable", pulsesTable);
        console.log("test 0", pulsesByHead);

        pulsesByHead.forEach((pulsesByAgroUnit, agroUnitIndex) => {
          console.log("test 1", pulsesByAgroUnit);

          // if (pulsesByAgroUnit !== undefined) {
          pulsesTable[index].push(
            pulsesByAgroUnit.map((singlePulse, i) => {
              console.log("pulsesByAgroUnit", pulsesByAgroUnit, agroUnitIndex);
              if (agroUnitIndex == 0) {
                newTimes.push([]);
              }

              console.log("Instructions", this.instructions[index][0][0]);

              singlePulse.totalMin =
                (this.splitIrrigationInstructions[index][agroUnitIndex]
                  .milliliters *
                  this.instructions[index][0][i].percentage) /
                // singlePulse.percentage) /
                100 /
                66.66;

              singlePulse.percentage = this.instructions[index][0][
                i
              ].percentage;

              singlePulse.electricConductivity = parseFloat(
                this.splitPulses[index][agroUnitIndex][i].electricConductivity
              );

              singlePulse.minFormated = this.$moment()
                .startOf("day")
                .add(singlePulse.totalMin, "minutes")
                .format("m[m]:ss[s]");
              return { ...singlePulse };
            })
          );

          // }
        });

        // console.log("pulsesArr", pulsesArr);
        // console.log("instructions..", this.instructions);

        this.pulsesTable = pulsesTable;
      });

      // CALCULATE INITIAL AND FINAL TIME
      pulsesTable.forEach((headPulses, headInd) => {
        let time = this.$moment(this.initialTimes[headInd], "HH:mm");
        let accIrrForPulse = new Array(headPulses[0].length).fill(0);

        // Cantidad de pulsos
        headPulses.forEach((irrPulses) => {
          irrPulses.forEach((pulse, pulInd) => {
            // console.log("Pulse Id", pulse.id);
            if (pulse.id) {
              // console.log("PULSE IND", pulInd);
              accIrrForPulse[pulInd] += pulse.totalMin;
            }
          });
        });

        let acc = 0;

        let initialTime = accIrrForPulse.map((totalByPulse, j) => {
          const inTime = this.$moment(time, "HH:mm")
            .add(acc, "minutes")
            .format("HH:mm");

          acc += totalByPulse + parseInt(headPulses[0][j].waitTime);

          return {
            minFormated: inTime,
            acc,
            electricConductivity: "",
          };
        });

        let resultTime = initialTime.map((t, tInd) => {
          // console.log("AccIrr", accIrrForPulse[tInd]);
          let minFormated = this.$moment(t.minFormated, "HH:mm")
            .add(accIrrForPulse[tInd], "minutes")
            .format("HH:mm");

          return {
            minFormated,
            electricConductivity: "",
          };
        });
        headPulses.push(initialTime);
        headPulses.push(resultTime);
      });

      if (pulsesArr.length > 1) {
        let firstPulses = [...pulsesArr[0]];
        let secondPulses = [...pulsesArr[1]];
        this.pulses = firstPulses.concat(secondPulses);
        // console.log("pul", this.pulses);
      } else {
        this.pulses = pulsesArr[0];
        // console.log("pul", this.pulses);
      }

      // console.log("cal:", this.splitIrrigationInstructions);

      // this.$store.commit("pulses", this.pulses);
      this.$store.commit("splitPulses", pulsesArr);
      this.$store.commit("pulsesTable", pulsesTable);
      this.$store.commit("pulsesHeaders", pulsesHeaders);

      // this.submit();
    },
    calcTotal() {
      this.total = 0;
      this.instructions[0][0].forEach((element) => {
        this.total += parseFloat(element.percentage);
      });
    },
    calcTotalB() {
      this.totalB = 0;
      this.instructions[1][0].forEach((element) => {
        this.totalB += parseFloat(element.percentage);
      });
      console.log(this.instructions);
    },
    clickPulse(event, k) {
      this.calculate(true);
      this.index = k;
      this.configPulse = true;
    },
    addPulse(i) {
      // console.log("addpulse", i);
      // console.log(this.instructions);
      // console.log(this.instructions[i]);
      // console.log(this.instructions[i][0]);
      let index = this.instructions[i][0].length + 1;
      this.instructions[i].forEach((InsPulseArr) => {
        // console.log(">>", InsPulseArr);
        InsPulseArr.push({
          id: Math.floor(Math.random() * 10000),
          position: index,
          percentage: "",
          electricConductivity: "0.8",
          waitTime: "0",
          totalMin: 0,
        });
      });

      if (this.instructions[i][0] !== undefined) {
        // console.log("chuy 1");
        this.newPulse = this.percentage[i] / this.instructions[i][0].length;
      } else {
        // console.log("chuy 2");
        this.newPulse = 100;
      }

      this.instructions[i].forEach((element) => {
        // console.log("el..", element);
        element.forEach((el) => {
          el.percentage = this.newPulse;
        });
      });
      // console.log(this.instructions);
    },
    removePulse(i) {
      console.log(i);
      this.instructions[i].forEach((element) => {
        element.splice(-1, 1);
        element.forEach((el) => {
          el.percentage = this.percentage[i] / this.instructions[i][0].length;
        });
      });
    },
    save(time) {
      // console.log("save1");
      this.initialTimes[0] = time;
    },
    save2(time2) {
      this.initialTimes[1] = time2;
      // console.log("save2", this.initialTimes);
    },
  },
};
</script>

<style scoped>
.v-toolbar {
  margin-bottom: 0px !important;
}

.v-icon {
  margin-right: 7px !important;
}

.agro-unit {
  margin-left: 10px;
}

.config-pulse {
  top: 5px;
}

.pulse-config {
  padding-left: 150px;
}

.head {
  width: 120px;
}

.content {
  padding-top: 20px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 30px;
}

.clickable {
  cursor: pointer;
}

.controls {
  margin-left: 10%;
}

.control {
  width: 10px !important;
}

.disable {
  background-color: white;
  opacity: 0.8;
}

.err {
  color: red !important;
  font-weight: bold;
}

input {
  background-color: rgba(190, 190, 190, 0.1);
  display: block !important;
  border: 0.5px solid lightgray !important;
  border-radius: 3px;
  padding: 8px;
  width: 120px;
}

.buttons {
  padding-left: 10px !important;
  padding-right: 135px !important;
}

.accept-pulse {
  margin-left: 60%;
  margin-top: -30px;
  display: inline-block;
}

.close {
  float: right;
  /* top: 5px; */
  /* margin-left: 90%; */
}
</style>
